import React from "react";
import {
  DescriptionOutlined,
  EmojiPeopleOutlined,
  ForumOutlined,
  GroupOutlined,
  EmojiObjectsOutlined,
  MemoryOutlined,
  SearchOutlined,
  TrendingUpOutlined,
  VideocamOutlined,
  WorkOutline,
} from "@material-ui/icons";

const icons: Record<string, React.ComponentType> = {
  description: DescriptionOutlined,
  emoji_people: EmojiPeopleOutlined,
  forum: ForumOutlined,
  groups: GroupOutlined,
  lightbulb: EmojiObjectsOutlined,
  memory: MemoryOutlined,
  search: SearchOutlined,
  trending_up: TrendingUpOutlined,
  videocam: VideocamOutlined,
  work: WorkOutline,
};

const BlogIcon = ({ name }: { name: string }) => {
  const Icon = icons[name] || EmojiObjectsOutlined;
  return <Icon />;
};

export default BlogIcon;
